// extracted by mini-css-extract-plugin
export var box = "SuccessModal-module--box--73486";
export var box_md = "SuccessModal-module--box_md--c2c47";
export var box_xmd = "SuccessModal-module--box_xmd--606ba";
export var box_flex = "SuccessModal-module--box_flex--1fca5";
export var box_lg = "SuccessModal-module--box_lg--2e9c5";
export var box_sm = "SuccessModal-module--box_sm--351e8";
export var box_outer = "SuccessModal-module--box_outer--f2495";
export var box_whiteBg = "SuccessModal-module--box_white-bg--100f1";
export var box_noMarginBottom = "SuccessModal-module--box_no-margin-bottom--9a8c2";
export var box_noPadding = "SuccessModal-module--box_no-padding--89be1";
export var box_outerGray = "SuccessModal-module--box_outer-gray--57d96";
export var box_dark = "SuccessModal-module--box_dark--d3356";
export var box_zIndex = "SuccessModal-module--box_z-index--922e8";
export var box_zIndex6 = "SuccessModal-module--box_z-index-6--b6da4";
export var box_eventsWithLine = "SuccessModal-module--box_events-with-line--8c599";
export var box_featuresAo = "SuccessModal-module--box_features-ao--7d22f";
export var box_verticalPaddings = "SuccessModal-module--box_vertical-paddings--3f525";
export var clearP = "SuccessModal-module--clearP--11e54";
export var clearP_vc = "SuccessModal-module--clearP_vc--d8987";
export var wrapper = "SuccessModal-module--wrapper--40920";
export var text = "SuccessModal-module--text--0eb6d";
export var icon = "SuccessModal-module--icon--44f6f";
export var matrixWrapper = "SuccessModal-module--matrixWrapper--b1a57";
export var matrixText = "SuccessModal-module--matrixText--d51a7";
export var matrixButton = "SuccessModal-module--matrixButton--c1021";
export var fadeInAnimation = "SuccessModal-module--fadeInAnimation--83e8d";
export var placeHolderShimmer = "SuccessModal-module--placeHolderShimmer--1888e";